f<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tablePatchDate" :loading="patchLoadings" height="500" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="detail">
                <span @click="detail(index)">
                    <Button type="info" size="small"  @click="patchDetailModal = true">{{ $t('alarms.common.details') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 补丁详情模式框 -->
        <Modal v-model="patchDetailModal" :title="$t('patch_management.patch_policy.patchDetail')" :mask-closable="false" width="800px">
            <Row style="width: 92%;margin: auto;">
                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">ID</Col>
                            <Col span="24">{{id}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.releaseDate') }} (UTC)</Col>
                            <Col span="24">{{releaseDate}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.title') }}</Col>
                            <Col span="24">{{title}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.vendor') }}</Col>
                            <Col span="24">{{vendor}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.productFamily') }}</Col>
                            <Col span="24">{{productFamily}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.product') }}</Col>
                            <Col span="24">{{product}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.classification') }}</Col>
                            <Col span="24">{{classification}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.severity') }}</Col>
                            <Col span="24">{{msrcSeverity}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">KB{{ $t('patch_management.patch_policy.number') }}</Col>
                            <Col span="24">{{kbNumber}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">MSRC{{ $t('patch_management.patch_policy.number') }}</Col>
                            <Col span="24">{{msrcNumber}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.language') }}</Col>
                            <Col span="24">{{language}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.description') }}</Col>
                            <Col span="24">{{description}}</Col>
                        </Row>
                    </Col>
                </Row>
            </Row>
            <div slot="footer">
                <Button size="large" @click="cancel">{{ $t('alarms.common.cancel') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    var tablePatchVue = {};
    export default {
        name: 'TablePatch',
        data () {
            return {
                patchDetailModal:false,
                patchLoadings:false,
                accountIdSearchKey:'',
                regionSearchKey:'',
                severitySearchKey:'',
                id:'',
                releaseDate:'',
                title:'',
                vendor:'',
                productFamily:'',
                product:'',
                classification:'',
                msrcSeverity:'',
                kbNumber:'',
                msrcNumber:'',
                language:'',
                description:'',
                columns: [
                    {
                        title: 'KB',
                        key: 'kbNumber'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.name'),
                        key: 'title'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.productSeries'),
                        key: 'productFamily'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.product'),
                        key: 'product'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.category'),
                        key: 'classification'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.severityLevel'),
                        key: 'msrcSeverity'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail'
                    }
                ],
                tablePatchDate:[]
            }
        },
        beforeCreate: function() {
            tablePatchVue = this
        },
        methods: {
            showAll: function(accountIdSearchKey,regionSearchKey,severitySearchKey){
                tablePatchVue.accountIdSearchKey = accountIdSearchKey;
                tablePatchVue.regionSearchKey = regionSearchKey;
                tablePatchVue.severitySearchKey = severitySearchKey;
                tablePatchVue.getPatchData();
            },
            // 分页显示数据
            /****************************************************/
            getPatchData:function() {
                this.patchLoadings = true;
                //分页
                this.$api.policy.listPatch({
                    "awssmPatcheRequestDTO" : {
                        // "maxResults":50,
                        "severity" : tablePatchVue.severitySearchKey
                    },
                    "accountId" : tablePatchVue.accountIdSearchKey,
                    "regionString" : tablePatchVue.regionSearchKey
                })
                .then(res => {
                    this.tablePatchDate = res.data.patches;
                    this.patchLoadings = false;
                });
            },
            // 详情
            /****************************************************/
            detail: function(index){
                this.lineIndex=index;
                this.id=this.tablePatchDate[index].id;
                this.releaseDate=this.tablePatchDate[index].releaseDate;
                this.title=this.tablePatchDate[index].title;
                this.vendor=this.tablePatchDate[index].vendor;
                this.productFamily=this.tablePatchDate[index].productFamily;
                this.product=this.tablePatchDate[index].product;
                this.classification=this.tablePatchDate[index].classification;
                this.msrcSeverity=this.tablePatchDate[index].msrcSeverity;
                this.kbNumber=this.tablePatchDate[index].kbNumber;
                this.msrcNumber=this.tablePatchDate[index].msrcNumber;
                this.language=this.tablePatchDate[index].language;
                this.description=this.tablePatchDate[index].description;
            },
            // 取消
            cancel:function(){
                this.patchDetailModal=false;
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/TablePatch.vue